// extracted by mini-css-extract-plugin
export default {"button":"OAuthButton_button__UFgNg","icon":"OAuthButton_icon__Dy47w","label":"OAuthButton_label__xmWfr","arrow":"OAuthButton_arrow__H65No"};